// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/routes/Forms/AdminPortal/AdminPortal.css */

.admin-portal-container {
    display: flex;
    flex-direction: column;
    background-color: #364C63;
}

.admin-portal {
    padding: 0.5rem;
    margin: auto;
    flex: 1 1;
    width: 100%;
}

.sectionnn {
    background: white;
    border-radius: 8px;
    padding: 5px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    width: 90%;
    display: flex;
    margin: auto;
    margin-bottom: 1rem;
    margin-top: 2rem;
    flex-direction: column;
}

.admin-portal-heading {
    color: #EF6F53  ;
    text-align: center;
    font-size: 1.75rem;
    font-weight: bold;
    letter-spacing: 0.05rem;
    margin-bottom: 1rem;
    margin-top: 1rem;
    text-align: center;
    text-transform: uppercase;
}

.error-messaage {
    background-color: #f8d7da;
    color: #c62828;
    padding: 10px;
    border-radius: 4px;
    margin-bottom: 1rem;
}

.success-message {
    background-color: #d4edda;
    color: #2e7d32;
    padding: 10px;
    border-radius: 4px;
    margin-bottom: 1rem;
}

.create-team-heading,
.create-user-heading,
.existing-user-heading {
    color: #EF6F53  ;
    text-align: center;
    font-size: 1.5rem;
    font-weight: bold;
    letter-spacing: 0.05rem;
    margin-bottom: 1rem;
    text-transform: uppercase;
}

.existing-user-heading {
    margin-top: 1rem;
}

.create-team-heading{
    margin-bottom: 0;
}

.team-inputsss{
    display: flex;
    flex-direction: row;
    margin-top: 0.25rem;

}
.team-inputt {
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-bottom: 20px;
    width: 100%;
}

.team-row {
    display: flex;
    gap: 10px;
    width: 100%;
}

.team-name-input {
    max-width: 40%;
    border: 1px solid #ccc;
    border-radius: 4px;
}

.tax-id-input,
.reg-no-input {
    max-width: 30%;
    border: 1px solid #ccc;
    border-radius: 4px;
}

.team-address-input {
    max-width: 80%;
    border: 1px solid #ccc;
    border-radius: 4px;
}

.team-country-input {
    max-width: 20%;
    border: 1px solid #ccc;
    border-radius: 4px;
}

.team-detail-input {
    max-width: 100%;
    border: 1px solid #ccc;
    border-radius: 4px;
    resize: none;
    height: 40px;
}

.team-inputt input,
.team-inputt textarea {
    flex: 1 1;
    padding: 2px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
}

.create-button {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #2196f3;
    color: white;
    border: none;
    border-radius: 10px;
    padding: 2px 8px;
    cursor: pointer;
    margin-top: 10px;
    margin: auto;
    transition: background-color 0.3s ease, transform 0.2s ease;
}

.create-button:hover {
    background-color: #007bff;
    transform: translateY(2px); 
}

.user-formm {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.user-inputs {
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-items: center;
    flex-wrap: wrap;
}

.user-inputs input,
.user-inputs select {
    padding: 2px;
    border: 1px solid #ddd;
    border-radius: 4px;
    flex: 1 1;
    min-width: 180px;
    max-width: 250px;
}

.users-list {
    width: 70%;
    margin: auto;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    margin-top: 1rem;
}

.team-section {
    width: 100%;
    margin: auto;
    background: rgb(250, 250, 250);
    border-radius: 15px;
    padding: 1rem;
    margin-bottom: 1rem;
    box-shadow: 0 5px 8px rgba(0, 0, 0, 0.5);
    transition: transform 0.2s, box-shadow 0.2s;
}

.team-section:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 8px rgba(0, 0, 0, 0.5);
    background: #e2e2e2;

}

.user-section {
    border-left: 4px solid #4CAF50;
    padding-left: 1rem;
}

.team-name {
    color: #364C63;
    font-size: 1.2rem;
    font-weight: bold;
    letter-spacing: 0.05rem;
    padding: 0.15rem;
    margin-bottom: 0.5rem;
    border-bottom: 1px solid #EF6F53;
    text-transform: uppercase;
    text-align: center;
    position: relative;
}

.team-name::after {
    content: '';
    position: absolute;
    bottom: -2px;
    left: 50%;
    transform: translateX(-50%);
    width: 50px;
    height: 2px;
    background-color: #2196f3;
}

.user-row {
    display: flex;
    padding: 0.15rem;
    border-bottom: 1px solid #f0f0f0;
    transition: background-color 0.2s;
}

.user-row:last-child {
    border-bottom: none;
}

.user-row:hover {
    background-color: #f9f9f9;
}

.user-row.header {
    background-color: #364C63;
    font-weight: bold;
    color: white;
    border-bottom: 1px solid #ddd;
    border-radius: 6px 6px 0 0;
}

.user-row.header .user-col {
    color: white;
    font-weight: bold;
    text-transform: uppercase;
    font-size: 0.9rem;
}

.user-col {
    flex: 1 1;
    padding: 0.1rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 0.9rem;
}

.user-col:first-child {
    font-weight: 500;
    color: #2196f3;
}

.user-col:nth-child(3) {
    text-transform: uppercase;
    font-weight: 500;
}

.message-container {
    position: fixed;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    padding: 15px 30px;
    border-radius: 6px;
    font-size: 15px;
    font-weight: 500;
    z-index: 9999;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    min-width: 300px;
    text-align: center;
    transition: opacity 0.3s ease-out;
}

.message-container.error {
    background-color: #fee2e2;
    color: #dc2626;
    border: 1px solid #fecaca;
    animation: slideDown 0.3s ease-out;
}

.message-container.success {
    background-color: #dcfce7;
    color: #16a34a;
    border: 1px solid #bbf7d0;
    animation: slideDown 0.3s ease-out;
}


@keyframes slideDown {
    from {
        transform: translate(-50%, -100%);
        opacity: 0;
    }
    to {
        transform: translate(-50%, 0);
        opacity: 1;
    }
}

@media (max-width: 768px) {
    .users-list {
        grid-template-columns: 1fr;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/routes/Forms/AdminPortal/AdminPortal.css"],"names":[],"mappings":"AAAA,4DAA4D;;AAE5D;IACI,aAAa;IACb,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,SAAO;IACP,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,wCAAwC;IACxC,UAAU;IACV,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;;;IAGI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;;AAEvB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,SAAS;IACT,WAAW;AACf;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;;IAEI,cAAc;IACd,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,YAAY;AAChB;;AAEA;;IAEI,SAAO;IACP,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,2DAA2D;AAC/D;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,eAAe;AACnB;;AAEA;;IAEI,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,SAAO;IACP,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,yCAAyC;IACzC,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,wCAAwC;IACxC,2CAA2C;AAC/C;;AAEA;IACI,2BAA2B;IAC3B,wCAAwC;IACxC,mBAAmB;;AAEvB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;IAChB,qBAAqB;IACrB,gCAAgC;IAChC,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,WAAW;IACX,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,gCAAgC;IAChC,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,YAAY;IACZ,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,SAAO;IACP,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,wCAAwC;IACxC,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;IACzB,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;IACzB,kCAAkC;AACtC;;;AAGA;IACI;QACI,iCAAiC;QACjC,UAAU;IACd;IACA;QACI,6BAA6B;QAC7B,UAAU;IACd;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":["/* src/components/routes/Forms/AdminPortal/AdminPortal.css */\n\n.admin-portal-container {\n    display: flex;\n    flex-direction: column;\n    background-color: #364C63;\n}\n\n.admin-portal {\n    padding: 0.5rem;\n    margin: auto;\n    flex: 1;\n    width: 100%;\n}\n\n.sectionnn {\n    background: white;\n    border-radius: 8px;\n    padding: 5px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    width: 90%;\n    display: flex;\n    margin: auto;\n    margin-bottom: 1rem;\n    margin-top: 2rem;\n    flex-direction: column;\n}\n\n.admin-portal-heading {\n    color: #EF6F53  ;\n    text-align: center;\n    font-size: 1.75rem;\n    font-weight: bold;\n    letter-spacing: 0.05rem;\n    margin-bottom: 1rem;\n    margin-top: 1rem;\n    text-align: center;\n    text-transform: uppercase;\n}\n\n.error-messaage {\n    background-color: #f8d7da;\n    color: #c62828;\n    padding: 10px;\n    border-radius: 4px;\n    margin-bottom: 1rem;\n}\n\n.success-message {\n    background-color: #d4edda;\n    color: #2e7d32;\n    padding: 10px;\n    border-radius: 4px;\n    margin-bottom: 1rem;\n}\n\n.create-team-heading,\n.create-user-heading,\n.existing-user-heading {\n    color: #EF6F53  ;\n    text-align: center;\n    font-size: 1.5rem;\n    font-weight: bold;\n    letter-spacing: 0.05rem;\n    margin-bottom: 1rem;\n    text-transform: uppercase;\n}\n\n.existing-user-heading {\n    margin-top: 1rem;\n}\n\n.create-team-heading{\n    margin-bottom: 0;\n}\n\n.team-inputsss{\n    display: flex;\n    flex-direction: row;\n    margin-top: 0.25rem;\n\n}\n.team-inputt {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    margin-bottom: 20px;\n    width: 100%;\n}\n\n.team-row {\n    display: flex;\n    gap: 10px;\n    width: 100%;\n}\n\n.team-name-input {\n    max-width: 40%;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n}\n\n.tax-id-input,\n.reg-no-input {\n    max-width: 30%;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n}\n\n.team-address-input {\n    max-width: 80%;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n}\n\n.team-country-input {\n    max-width: 20%;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n}\n\n.team-detail-input {\n    max-width: 100%;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    resize: none;\n    height: 40px;\n}\n\n.team-inputt input,\n.team-inputt textarea {\n    flex: 1;\n    padding: 2px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    font-size: 14px;\n}\n\n.create-button {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: #2196f3;\n    color: white;\n    border: none;\n    border-radius: 10px;\n    padding: 2px 8px;\n    cursor: pointer;\n    margin-top: 10px;\n    margin: auto;\n    transition: background-color 0.3s ease, transform 0.2s ease;\n}\n\n.create-button:hover {\n    background-color: #007bff;\n    transform: translateY(2px); \n}\n\n.user-formm {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}\n\n.user-inputs {\n    display: flex;\n    flex-direction: row;\n    gap: 10px;\n    align-items: center;\n    flex-wrap: wrap;\n}\n\n.user-inputs input,\n.user-inputs select {\n    padding: 2px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    flex: 1;\n    min-width: 180px;\n    max-width: 250px;\n}\n\n.users-list {\n    width: 70%;\n    margin: auto;\n    border-radius: 12px;\n    overflow: hidden;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n    margin-top: 1rem;\n}\n\n.team-section {\n    width: 100%;\n    margin: auto;\n    background: rgb(250, 250, 250);\n    border-radius: 15px;\n    padding: 1rem;\n    margin-bottom: 1rem;\n    box-shadow: 0 5px 8px rgba(0, 0, 0, 0.5);\n    transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.team-section:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 5px 8px rgba(0, 0, 0, 0.5);\n    background: #e2e2e2;\n\n}\n\n.user-section {\n    border-left: 4px solid #4CAF50;\n    padding-left: 1rem;\n}\n\n.team-name {\n    color: #364C63;\n    font-size: 1.2rem;\n    font-weight: bold;\n    letter-spacing: 0.05rem;\n    padding: 0.15rem;\n    margin-bottom: 0.5rem;\n    border-bottom: 1px solid #EF6F53;\n    text-transform: uppercase;\n    text-align: center;\n    position: relative;\n}\n\n.team-name::after {\n    content: '';\n    position: absolute;\n    bottom: -2px;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 50px;\n    height: 2px;\n    background-color: #2196f3;\n}\n\n.user-row {\n    display: flex;\n    padding: 0.15rem;\n    border-bottom: 1px solid #f0f0f0;\n    transition: background-color 0.2s;\n}\n\n.user-row:last-child {\n    border-bottom: none;\n}\n\n.user-row:hover {\n    background-color: #f9f9f9;\n}\n\n.user-row.header {\n    background-color: #364C63;\n    font-weight: bold;\n    color: white;\n    border-bottom: 1px solid #ddd;\n    border-radius: 6px 6px 0 0;\n}\n\n.user-row.header .user-col {\n    color: white;\n    font-weight: bold;\n    text-transform: uppercase;\n    font-size: 0.9rem;\n}\n\n.user-col {\n    flex: 1;\n    padding: 0.1rem;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-size: 0.9rem;\n}\n\n.user-col:first-child {\n    font-weight: 500;\n    color: #2196f3;\n}\n\n.user-col:nth-child(3) {\n    text-transform: uppercase;\n    font-weight: 500;\n}\n\n.message-container {\n    position: fixed;\n    top: 20px;\n    left: 50%;\n    transform: translateX(-50%);\n    padding: 15px 30px;\n    border-radius: 6px;\n    font-size: 15px;\n    font-weight: 500;\n    z-index: 9999;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    min-width: 300px;\n    text-align: center;\n    transition: opacity 0.3s ease-out;\n}\n\n.message-container.error {\n    background-color: #fee2e2;\n    color: #dc2626;\n    border: 1px solid #fecaca;\n    animation: slideDown 0.3s ease-out;\n}\n\n.message-container.success {\n    background-color: #dcfce7;\n    color: #16a34a;\n    border: 1px solid #bbf7d0;\n    animation: slideDown 0.3s ease-out;\n}\n\n\n@keyframes slideDown {\n    from {\n        transform: translate(-50%, -100%);\n        opacity: 0;\n    }\n    to {\n        transform: translate(-50%, 0);\n        opacity: 1;\n    }\n}\n\n@media (max-width: 768px) {\n    .users-list {\n        grid-template-columns: 1fr;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
